module.exports = __webpack_public_path__ + "static/landing-hero-9b0127cfc79cde6f5117437e92a3ce7d.png";